export default "__VITE_ASSET__9daaeda3__"